import axios from "axios";

export default {
    namespaced: true,
    state: {
        stores: [],
        store: [],
        meta: [],
    },
    mutations: {
        setStores(state, stores) {
            state.stores = stores
        },
        setStore(state, store) {
            state.store = store
        },
        setMeta(state, meta) {
            state.meta = meta
        }
    },
    actions: {
        getStores({commit}, page = 1) {
            axios.get(`/multiple-store?page=${page}`).then(res => {
                const data = res.data.data
                commit('setStores', data.data)
                commit('setMeta', data.meta)
            })

        },
        getAllStoresWithoutState({commit}) {
            return axios.get(`/multiple-store/all`)
        },
        getSingleStore({commit}, store_id) {
            axios.get(`/multiple-store/${store_id}`).then(res => {
                const data = res.data
                commit('setStore', data.data)
            })
        },
        getSingleStoreWithoutState({commit}, store_id) {
            return axios.get(`/multiple-store/${store_id}`)
        }
    },
    getters: {
        getStores: state => state.stores,
        getStore: state => state.store,
        getMeta: state => state.meta,
    }

}